module.exports = __webpack_public_path__ + "static/media/UN-02.f376a769.jpg";